// src/services/common-service.js
import axios from "axios";
import { baseURLWithoutVersion } from "../config/setting";

/**
 * Slugs que NO representan asociaciones reales.
 * Añade aquí cualquier otro slug “reservado”
 * que no deba hacer la llamada a /custom/<slug>/.
 */
const RESERVED_SLUGS = [
  "cert-login",
  "login",
  // "summary", "pdf-viewer", …  si lo necesitas
];

export const CommonService = {
  /**
   * Devuelve las propiedades de personalización.
   * Si el slug está reservado o es vacío, NO hace petición y
   * resuelve la Promesa con { data: null } para mantener la API.
   *
   * @param {string|null|undefined} associationName
   * @returns {Promise<{data: any}>}
   */
  getCustomPropertise(associationName) {
    const slug = String(associationName || "").toLowerCase();

    // 1) Sin slug → no hacemos nada
    if (!slug) {
      console.info("[CommonService] slug vacío, se omite llamada");
      return Promise.resolve({ data: null });
    }

    // 2) Slug reservado → saltamos llamada
    if (RESERVED_SLUGS.includes(slug)) {
      console.info("[CommonService] slug reservado, se omite llamada:", slug);
      return Promise.resolve({ data: null });
    }

    // 3) Slug “normal” → petición real
    const url = `${baseURLWithoutVersion}custom/${slug}/`;
    console.info("[CommonService] GET", url);
    return axios.get(url);
  },
};
